import { render, staticRenderFns } from "./SavedQuotes.vue?vue&type=template&id=7478a6dd&scoped=true"
import script from "./SavedQuotes.vue?vue&type=script&lang=js"
export * from "./SavedQuotes.vue?vue&type=script&lang=js"
import style0 from "./SavedQuotes.vue?vue&type=style&index=0&id=7478a6dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7478a6dd",
  null
  
)

export default component.exports